import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Routes } from '../../config/routes';
import { ApplicationHttpClient } from '../../components/shared/http/application-http-client';

interface EvictionEventRequest {
    eventType: 'super_eviction';
    reason: string;
    metadata: {
        sentOrgId: number | null;
        currentOrgId: number | null;
    };
}

/**
 * Emits the super_eviction meter (SD-7928) so SD-7885's before/after becomes
 * measurable. A genuine super-user eviction is only distinguishable from a benign
 * 401 and the SD-7885 quiet-abandon on the client, so the event must be emitted
 * from RefreshTokenInterceptor's eviction chokepoint — before the JWT is cleared,
 * so the POST is still authenticated and lands a user-attributed row in
 * user_auth_events. Mirrors TimeoutLoggingService (the only other client emitter
 * for that table) and is fire-and-forget: failures are swallowed so instrumentation
 * can never re-enter or break the 401 pipeline.
 */
@Injectable({
    providedIn: 'root',
})
export class EvictionLoggingService {
    constructor(private _http: ApplicationHttpClient) {}

    logSuperEviction(sentOrgId: number | null, currentOrgId: number | null): Observable<void> {
        const request: EvictionEventRequest = {
            eventType: 'super_eviction',
            reason: 'Super-user evicted on same-context 401',
            metadata: {
                sentOrgId: sentOrgId,
                currentOrgId: currentOrgId,
            },
        };

        const url = Routes.MakeLegFiCoreUrl(Routes.LegFiCore.TimeoutEvent);

        return this._http.post<void>(url, JSON.stringify(request)).pipe(
            catchError((error) => {
                console.error('Failed to log super-eviction event:', error);
                return of(void 0);
            }),
        );
    }
}
